import {MatCardModule} from '@angular/material/card';
import {Component} from '@angular/core';

@Component({
    templateUrl: './sommertraining-page.component.html',
    styleUrls: ['./sommertraining-page.component.scss'],
    imports: [MatCardModule]
})
export class SommertrainingPageComponent {
    bilderliste = [
        'assets/img/sportliches/sommer/sommer_1.jpg',
        'assets/img/sportliches/sommer/sommer_2.jpg',
        'assets/img/sportliches/sommer/sommer_3.jpg',
        'assets/img/sportliches/sommer/sommer_4.jpg',
        'assets/img/sportliches/sommer/sommer_5.jpg',
        'assets/img/sportliches/sommer/sommer_6.jpg',
    ];
}
